var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDaySheets(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7578 4.10156C11.7578 5.07086 12.5463 5.85938 13.5156 5.85938H17.6172V18.2422C17.6172 19.2115 16.8287 20 15.8594 20H4.14062C3.17133 20 2.38281 19.2115 2.38281 18.2422V1.75781C2.38281 0.788516 3.17133 0 4.14062 0H11.7578V4.10156ZM6.48438 8.24219C6.16051 8.24219 5.89844 8.50426 5.89844 8.82812V15.8594C5.89844 16.1832 6.16051 16.4453 6.48438 16.4453H13.5156C13.8395 16.4453 14.1016 16.1832 14.1016 15.8594V8.82812C14.1016 8.50426 13.8395 8.24219 13.5156 8.24219H6.48438ZM9.41406 15.2734H7.07031V14.1016H9.41406V15.2734ZM12.9297 15.2734H10.5859V14.1016H12.9297V15.2734ZM9.41406 12.9297H7.07031V11.7578H9.41406V12.9297ZM12.9297 12.9297H10.5859V11.7578H12.9297V12.9297ZM9.41406 10.5859H7.07031V9.41406H9.41406V10.5859ZM12.9297 10.5859H10.5859V9.41406H12.9297V10.5859ZM17.2734 4.6875H13.5156C13.1923 4.6875 12.9297 4.42484 12.9297 4.10156V0.34375L17.2734 4.6875Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDaySheets);
export default __webpack_public_path__ + "static/media/day-sheets.e6aeeb062294828dbb42cb881afa9718.svg";
export { ForwardRef as ReactComponent };